import React from 'react';

type AppProps = {
  value: number;
  testId?: string | null;
};

const Distance: React.FC<AppProps> = ({ value, testId = null }) => {
  return (
    <p className="text-sm font-medium" data-testid={testId}>
      {value ? `${value} mi` : '0 mi'}
    </p>
  );
};

export default Distance;
